exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mydoctor{margin-right:.25rem}.mytips{font-size:.625rem;background:#fff;color:gray}.myfee{margin-right:.25rem}.goPay{height:2.75rem;background-color:#fff;width:100%;font-size:.9rem;line-height:2.75rem;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76a283bb","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/myregister/RegDetail.vue
// module id = 472
// module chunks = 0